<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }
    Date.prototype.diffMonth = function (d) {
        return (this.getFullYear() * 12 + this.getMonth()) - (d.getFullYear() * 12 + d.getMonth())
    }

    import {Line} from  'vue-chartjs'
    import db from '@/firebase/firestore.js'
    import zoom from "chartjs-plugin-zoom"

    export default {
        extends: Line,
        props: {
            /** BOXマスター */
            boxMaster: null,
            /**
             * 表示対象のセンサー(複数)
             */
            sensors: null,
            /**
             * 表示条件
             */
            condition: {
                type: Object,
                default: function () {
                    return {
                        /** 表示範囲("month"-月,"day"-1日) */
                        range: "month",
                        /** 年(表示範囲="月"の時に有効) */
                        year: 2020,
                        /** 月(表示範囲="月"の時に有効) */
                        month: 8,
                        /** 日付(表示範囲="日"の時に有効) */
                        date: "",
                        /** 日付(開始)(表示範囲="日範囲"の時に有効) */
                        dateFrom: "",
                        /** 日付(終了)(表示範囲="日範囲"の時に有効) */
                        dateTo: ""
                    }
                }
            },
            /** 選択されているセンサー */
            selectedSensor: null,
            /** チャート上に重ねる警報のリスト */
            alarmsOnChart: null,
            /** チャートのオプション項目 */
            controlValues: null,
            /** ガイドライン */
            guideLine: null
        },
        data () {
            return {
                // センサー毎の日別の測定値
                measureRecords: {},
                // チャートデータ
                chartData: {
                    // データ
                    data: null,
                    // 表示オプション
                    options: null,
                },
                // センサー毎のスナップショットリスナーのデタッチを行うファンションが格納される配列
                snapShotRefs: [],
                // 表示中の範囲
                viewRange: {
                    from: null,
                    to: null
                },
                /** 最後にツールチップが表示された位置(x) */
                lastViewTooltipPointX: null,
                /** 行われている操作の状態 */
                operationState: {
                    startX: 0,
                    startPosition: 0,
                    isSwiping: false,
                }
            }
        },
        watch: {
            /**
             * 変更監視:ガイドライン表示/非表示
             */
            "guideLine.isVisible": function (value, old) {
                console.log("guide line changed(visible)", value, old)
                const guideLineDataset = this.chartData.data.datasets.find((v)=>v.additionalData != null && v.additionalData.type == "guide_line")
                if (guideLineDataset == null) {
                    console.log("guide line dataset none!")
                    return
                }
                guideLineDataset.showLine = this.guideLine.isVisible
                this.renderChart(this.chartData.data, this.chartData.options)
            },
            /**
             * 変更監視:ガイドライン位置
             */
            "guideLine.x": function (value, old) {
                console.log("guide line changed(x)", value, old)
                const guideLineDataset = this.chartData.data.datasets.find((v)=>v.additionalData != null && v.additionalData.type == "guide_line")
                if (guideLineDataset == null) {
                    console.log("guide line dataset none!")
                    return
                }
                guideLineDataset.data[0].x = this.guideLine.x
                guideLineDataset.data[1].x = this.guideLine.x
                this.renderChart(this.chartData.data, this.chartData.options)
            },
            /**
             * 変更監視:センサー数
             */
            "sensors.length": function (value, old) {
                this.startMeasureRecordWatch()
                this.refresh()
            },
            /**
             * 変更監視:表示条件
             */
            condition: {
                handler: function (value, old) {
                    // console.log("ChartSensor", "watch", "condition", "changed!", value)
                    this.refresh()
                },
                deep: true
            },
            /**
             * 変更監視:選択されているセンサー
             */
            selectedSensor: function (value, old) {
                // if (value == null) return
                // console.log("ChartSensor.watch.selectedSensor", value)
                const datasets = this.chartData.data.datasets.filter((v)=>v.additionalData != null && v.additionalData.type == "measure_dataset")
                for (var dataset of datasets) {
                    if (value != null && dataset.additionalData.sensor.body.sensorKey == value.body.sensorKey) {
                        dataset.borderColor = "rgba(255,0,0,0.7)"
                        dataset.borderWidth = 4
                    } else {
                        dataset.borderColor = "rgba(0,0,0,0.7)"
                        dataset.borderWidth = 2
                    }
                }
                this.renderChart(this.chartData.data, this.chartData.options)
            },
            /**
             * 変更監視:チャートデータ
             */
            chartData: function (value, old) {
                const self = this

                // this.chartData = value
                this.renderChart(this.chartData.data, this.chartData.options)
            },
            /**
             * 変更監視:チャート上にセットする警報
             */
            alarmsOnChart: {
                handler: function (value, old) {
                    const newDatasets = this.chartData.data.datasets.filter((v)=>v.additionalData != null && v.additionalData.type != "alarm_dataset")
                    this.chartData.data.datasets = newDatasets
                    this.setAlarms()
                    this.renderChart(this.chartData.data, this.chartData.options)
                },
                deep: true
            },
            /**
             * 変更監視:Y軸の範囲のチェック
             */
            "controlValues.enabledYAxisFitValue": function (value, old) {
                console.log("controlValues.enabledYAxisFitValue changed", value, old)
                const chartData = this.chartData
                this.refreshYAxisRange(chartData)
                this.chartData = chartData
                this.renderChart(this.chartData.data, this.chartData.options)
            },
            // "controlValues.height": function (value, old) {
            //     console.log("controlValues.height changed", value, old)
            //     this.renderChart(this.chartData.data, this.chartData.options)
            // }
            "controlValues.zoom": function (value, old) {
                this.onChangedZoomPan()
            },
            "controlValues.position": function (value, old) {
                this.onChangedZoomPan()
            },            
        },
        created: function () {
            // console.log("ChartSensor", "created")
        },
        mounted: function () {
            const self = this

            // this.addPlugin(zoom)

            this.startMeasureRecordWatch()

            this.$refs.canvas.addEventListener("mousedown", (e)=>self.onMouseDown(e.clientX, e.clientY))
            this.$refs.canvas.addEventListener("touchstart", (e)=>self.onMouseDown(e.changedTouches[0].clientX, e.changedTouches[0].clientY))
            // this.$refs.canvas.addEventListener(
            //     "touchstart", 
            //     function (e) {
            //         console.log(e.changedTouches.length)
            //         if (e.changedTouches.length == 2) {
            //             self.onStartPichInOut(e.changedTouches)
            //         } else {
            //             // 1本指のタッチの時は、パン
            //             self.onMouseDown(e.changedTouches[0].clientX, e.changedTouches[0].clientY)
            //         }
            //     }
            // )
            this.$refs.canvas.addEventListener("mouseup", (e)=>self.onMouseUp(e.clientX, e.clientY))
            this.$refs.canvas.addEventListener("touchend", (e)=>self.onMouseUp(e.changedTouches[0].clientX, e.changedTouches[0].clientY))
            this.$refs.canvas.addEventListener("mousemove", (e)=>self.onMouseMove(e.clientX, e.clientY))
            this.$refs.canvas.addEventListener(
                "touchmove", 
                function (e) {
                    self.onMouseMove(e.changedTouches[0].clientX, e.changedTouches[0].clientY)
                }
            )

        },
        beforeDestroy: function () {
            // console.log("beforeDestroy")
            for (var ref of this.snapShotRefs) {
                ref()
                // console.log("snapshot listening stop")
            }
        },
        methods: {
            /**
             * マウスクリック時
             * スワイプ処理を開始
             */
            onMouseDown: function (x, y) {
                this.operationState.startX = x
                this.operationState.startPosition = this.controlValues.position
                this.operationState.isSwiping = true
                // console.log("onMouseDown", this.operationState)
            },
            /**
             * マウスボタンリリース時
             * スワイプ処理を終了
             */
            onMouseUp: function (x, y) {
                this.operationState.isSwiping = false
                // console.log("onMouseDown", this.operationState)
            },
            /**
             * マウス移動時
             */
            onMouseMove: function (x, y) {
                if (!this.operationState.isSwiping) return
                // キャンパスの領域を取得
                const canvasRect = this.$refs.canvas.getBoundingClientRect()
                // 移動量
                const moveAmountX = this.operationState.startX - x                
                // キャンバス幅に対する移動量の割合
                const r = moveAmountX / canvasRect.width
                // X軸の時間枠に対する移動量の割合から、移動させる時間量
                const moveTime = this.controlValues.viewRange() * r
                // 全体の時間量に対する移動させる時間量の割合
                const p = moveTime / this.controlValues.maxRange()
                // 位置に対して、時間量の割合を加算
                this.controlValues.position = this.operationState.startPosition + p
                if (this.controlValues.position < 0) this.controlValues.position = 0
                if (this.controlValues.position > 1) this.controlValues.position = 1
                // console.log(moveAmountX, r)
            },
            // onStartPichInOut: function (touches) {
            //     console.log("distance", this.getDistance(touches[0].clientX, touches[0].clientY, touches[1].clientX, touches[1].clientY))
            // },
            getDistance: function (x1, y1, x2, y2) {
                return Math.sqrt(Math.pow(x2-x1, 2) + Math.pow(y2-y1, 2)) 
            },
                // dragInfo: {
                //     startX: 0,
                //     startPosition: 0,
                //     isDragging: false,
                //     startFingerDistance: 0,
                //     startZoom: 0,
                //     isZooming: false
                // }

            /**
             * 拡大、位置設定の値変更時
             */
            onChangedZoomPan: function () {
                // console.log("onChangedZoomPan")
                const chartData = this.chartData
                chartData.options.scales.xAxes[0].ticks.min = new Date(this.controlValues.from()).toFormatString("yyyy-MM-dd HH:mm")
                chartData.options.scales.xAxes[0].ticks.max = new Date(this.controlValues.to()).toFormatString("yyyy-MM-dd HH:mm")
                this.chartData = chartData
                this.renderChart(this.chartData.data, this.chartData.options)
            },
            /**
             * 各センサーの測定結果の更新の監視を開始する
             * 既に開始されている場合は、一旦終了する
             */
            startMeasureRecordWatch: function () {
                const self = this

                /** 現在の監視を終了させる */
                for (var ref of this.snapShotRefs) {
                    ref()
                }

                /** 改めて各センサー毎の監視を開始 */
                this.snapShotRefs = []

                const currentDate = (new Date()).toFormatString("yyyy-MM-dd")

                this.sensors.forEach(function(sensor){
                    const ref = db.collection("environments").doc(sensor.boxMaster.boxIdentificationCode)
                    .collection("sensors").doc(sensor.body.sensorKey)
                    .collection("records").doc(currentDate)
                    
                    console.log("measure record watch start", sensor.body.sensorKey)
                    // self.snapShotRefs.push(ref)
                    
                    self.snapShotRefs.push(
                        ref.onSnapshot(function(doc){
                            // console.log("snapshot changed", currentDate, self.viewRange)
                            if (self.viewRange.from == null || self.viewRange.to == null) {
                                self.refresh()
                            } else {
                                const fromDate = (new Date(self.viewRange.from)).toFormatString("yyyy-MM-dd")
                                const toDate = (new Date(self.viewRange.to)).toFormatString("yyyy-MM-dd")
                                if (currentDate >= fromDate && currentDate < toDate && self.chartData.data != null) {
                                    
                                    // self.refresh()

                                    const targetDataset = self.chartData.data.datasets.find((v)=>v.additionalData != null && v.additionalData.type == "measure_dataset" && v.additionalData.sensor.body.sensorKey == sensor.body.sensorKey)

                                    if (targetDataset != null) {
                                        const record = doc.data()
                                        const value = record.values[record.values.length - 1]
                                    
                                        const measureValue = value.value
                                        const x = record.date + " " + value.time
                                        const y = measureValue
                                        const data = {
                                            x: x,
                                            y: y,
                                            additionalData: {
                                                type: "measure_value",
                                                dateTime: record.date + " " + value.time,
                                                value: value,
                                                sensor: sensor
                                            }
                                        }
                                        targetDataset.data.push(data)
                                        self.renderChart(self.chartData.data, self.chartData.options)

                                        console.log("measure record updated", "dataset update success", sensor.body.sensorKey)
                                    } else {
                                        console.log("measure record updated", "dataset find failed", sensor.body.sensorKey)
                                    }
                                }
                            }
                        })
                    )
                })
            },
            /**
             * チャート更新
             */
            refresh: async function () {
                
                // console.log("ChartSensor", "refresh", "start")

                const self = this
                const lastDate = new Date(this.condition.year, this.condition.month, 0)

                /**
                 * チャートデータ
                 */
                const chartData = {
                    data: {
                        datasets: []
                    },
                    options: {
                        // events: ["click", "mousemove", "mouseout", "touchstart", "touchmove", "touchend"],
                        // onHover: function (event, data) {
                        //     const guideLineDataset = self.chartData.data.datasets.find((v)=>v.additionalData.type == "guide_line")
                        //     if (guideLineDataset == null) {
                        //         return
                        //     }
                        //     if (data.length == 0) {
                        //         guideLineDataset.showLine = false
                        //     }
                        //     guideLineDataset.showLine = true
                        // },
                        hover: {
                            mode: "nearest",
                            axis: "x",
                            intersect: false
                        },
                        // zoom: {
                        //     enabled: false,
                        //     mode: "x"
                        // },
                        // pan: {
                        //     enabled: false,
                        //     mode: "x"
                        // },
                        onClick: function (point, event) {
                            self.$emit("click", self.lastViewTooltipPointX)
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {
                            duration: 0
                        },
                        legend: {
                            display: false
                        },
                        tooltips: {
                            enabled: true,
                            titleFontSize: 20,
                            backgroundColor: "rgba(255,255,255,0.8)",
                            borderColor: "rgba(255,0,0,1)",
                            titleFontColor: "rgba(0,0,0,1)",
                            mode: "nearest",
                            axis: "x",
                            intersect: false
                        },
                        scales: {
                            yAxes: [
                                {
                                    id: "y-1",
                                    scaleLabel: {
                                        display: false,
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 5,
                                        fontSize: 11
                                    },
                                    gridLines: {
                                        tickMarkLength: 0,
                                        color: "rgba(0,0,255,0.4)",
                                        borderDash: [2, 1]
                                    },
                                    position: "left",
                                    display: true
                                },
                                {
                                    id: "y-2",
                                    scaleLabel: {
                                        display: false,
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 5,
                                        fontSize: 9
                                    },
                                    gridLines: {
                                        tickMarkLength: 0,
                                        color: "rgba(0,192,0,0.8)",
                                        borderDash: [2, 1]
                                    },
                                    position: "right",
                                    display: true
                                }
                            ],
                            xAxes: [
                                {
                                    scaleLabel: {
                                        display: false,
                                        labelString: '日'
                                    },
                                    type: "time",
                                    time: {
                                        unit: "day",
                                    },
                                    gridLines: {
                                        tickMarkLength: 0
                                    },
                                    ticks: {
                                        fontSize: 11,
                                        maxRotation: 0,
                                        autoSkip: false,
                                        source: "date",
                                        padding: 5,
                                        min: "2020-08-01",
                                        max: "2020-08-31",
                                    }
                                }
                            ]
                        }
                    }
                }
                
                // console.log(chartData)

                /**
                 * 表示=日範囲で From>=To の時は値を入れ替える
                 */
                if (this.condition.range == "day_range" && this.condition.dateFrom > this.condition.dateTo) {
                    const w = this.condition.dateFrom
                    this.condition.dateFrom = this.condition.dateTo
                    this.condition.dateTo = w
                }

                /**
                 * X軸設定
                 */
                if (this.controlValues.zoom == 0 && this.controlValues.position == 0) {
                    switch (this.condition.range) {
                        case "month":
                            chartData.options.scales.xAxes[0].ticks.min = this.condition.year + "-" + this.condition.month + "-01 00:00"
                            chartData.options.scales.xAxes[0].ticks.max = this.condition.year + "-" + this.condition.month + "-" + lastDate.getDate() + " 23:59"
                            chartData.options.scales.xAxes[0].time.unit = "day"
                            chartData.options.scales.xAxes[0].time.stepSize = 1
                            break;
                        case "day":
                            const xDate = new Date(this.condition.date)
                            chartData.options.scales.xAxes[0].ticks.min = xDate.toFormatString("yyyy-MM-dd 00:00")
                            chartData.options.scales.xAxes[0].ticks.max = xDate.toFormatString("yyyy-MM-dd 24:00")
                            chartData.options.scales.xAxes[0].time.unit = "minute"
                            chartData.options.scales.xAxes[0].time.stepSize = 60

                            // pan テスト(Chrome以外は動作しない…)
                            // chartData.options.scales.xAxes[0].ticks.min = xDate.toFormatString("yyyy-MM-dd 02:00")
                            // chartData.options.scales.xAxes[0].ticks.max = xDate.toFormatString("yyyy-MM-dd 08:00")
                            // chartData.options.pan = {
                            //     enabled: true,
                            //     mode: "x",
                            //     rangeMin: {x: new Date(xDate.toFormatString("yyyy-MM-dd 00:00")).getTime()},
                            //     rangeMax: {x: new Date(xDate.toFormatString("yyyy-MM-dd 24:00")).getTime()}
                            // }
                            break;
                        case "day_range":
                            const xDateFrom = new Date(this.condition.dateFrom)
                            const xDateTo = new Date(this.condition.dateTo)
                            chartData.options.scales.xAxes[0].ticks.min = xDateFrom.toFormatString("yyyy-MM-dd 00:00")
                            chartData.options.scales.xAxes[0].ticks.max = xDateTo.toFormatString("yyyy-MM-dd 24:00")
                            chartData.options.scales.xAxes[0].time.unit = "hour"
                            chartData.options.scales.xAxes[0].time.stepSize = 12
                            break;
                    }
                } else {
                    chartData.options.scales.xAxes[0].ticks.min = new Date(this.controlValues.from()).toFormatString("yyyy-MM-dd HH:mm")
                    chartData.options.scales.xAxes[0].ticks.max = new Date(this.controlValues.to()).toFormatString("yyyy-MM-dd HH:mm")
                    switch (this.condition.range) {
                        case "month":
                            chartData.options.scales.xAxes[0].time.unit = "day"
                            chartData.options.scales.xAxes[0].time.stepSize = 1
                            break;
                        case "day":
                            const xDate = new Date(this.condition.date)
                            chartData.options.scales.xAxes[0].time.unit = "minute"
                            chartData.options.scales.xAxes[0].time.stepSize = 60
                            break;
                        case "day_range":
                            chartData.options.scales.xAxes[0].time.unit = "hour"
                            chartData.options.scales.xAxes[0].time.stepSize = 12
                            break;
                    }
                }
                
                chartData.options.scales.xAxes[0].ticks.callback = function (value, index,values) {
                    /**
                     * X軸のラベル描画
                     */
                    const d = new Date(values[index].value)
                    switch (self.condition.range) {
                        case "month":
                            if (d.getDate() == 1) {
                                return (d.getMonth()+1) + "/1"
                            } else {
                                if (self.$vuetify.breakpoint.xs) {
                                    if (d.getDate() % 2 == 0) {
                                        return d.getDate()
                                    } else {
                                        return ""
                                    }
                                } else {
                                    return d.getDate()
                                }
                            }
                            break;
                        case "day":
                            const hour = d.getHours()
                            if ((hour % 3) == 0) {
                                return d.toFormatString("HH:mm")
                            } else {
                                return ""
                            }
                            // if (self.$vuetify.breakpoint.xs) {
                            //     const hour = d.getHours()
                            //     if (hour == 0 || hour == 3 || hour == 6 || hour == 9 || hour == 12 || hour == 15 || hour == 18 || hour == 21) {
                            //         return d.toFormatString("HH:mm")
                            //     } else {
                            //         return ""
                            //     }
                            // } else {
                            //     return d.toFormatString("HH:mm")
                            // }
                        case "day_range":
                            if (index == 0 || d.getHours() == 0) {
                                return (d.getMonth()+1) + "/" + d.getDate()
                            } else {
                                return d.getHours() + ":00"
                            }
                            break;
                    }
                }

                /**
                 * オプション設定
                 */
                chartData.options.tooltips.callbacks = {
                    /**
                     * ツールチップのタイトル表示
                     */
                    title: function (tooltipItem, chart) {
                        const dataset = chart.datasets[tooltipItem[0].datasetIndex]
                        if (dataset.additionalData == null) {
                            return ""
                        }
                        const data = dataset.data[tooltipItem[0].index]
                        const x = data.x
                        const y = data.y
                        const messages = []

                        self.lastViewTooltipPointX = data.x

                        switch (dataset.additionalData.type) {
                            case "measure_dataset":

                                // const guideLineDataset = chart.datasets.find((v)=>v.additionalData.type == "guide_line")
                                // if (guideLineDataset != null) {
                                //     guideLineDataset.data[0].x = x
                                //     guideLineDataset.data[1].x = x
                                //     self.$data._chart.update()// chart.update()
                                // }
                                messages.push(x)
                                for (var sensor of self.sensors) {
                                    const sensorDataset = self.chartData.data.datasets.find((v)=>v.additionalData.sensor != null && v.additionalData.type == "measure_dataset" && v.additionalData.sensor.body.sensorKey == sensor.body.sensorKey)
                                    if (sensorDataset != null) {
                                        const sensorData = sensorDataset.data.find((v)=>v.x == x)
                                        if (sensorData != null) {
                                            messages.push(sensorDataset.additionalData.sensor.body.name + " ... " + sensorData.additionalData.value.value.toFixed(1) + sensorData.additionalData.sensor.body.unit)
                                        }
                                    }
                                }
                                break;
                            case "min_limit_dataset":
                                messages.push("下限値")
                                for (var sensor of self.sensors) {
                                    const sensorDataset = self.chartData.data.datasets.find((v)=>v.additionalData.sensor != null && v.additionalData.type == "min_limit_dataset" && v.additionalData.sensor.body.sensorKey == sensor.body.sensorKey)
                                    if (sensorDataset != null && sensorDataset.data[0].y == y) {
                                        messages.push(sensorDataset.additionalData.sensor.body.name + " ... " + sensorDataset.additionalData.sensor.body.alarms.measure.min.value + sensorDataset.additionalData.sensor.body.unit)
                                    } else {
                                        console.log("sensor upper limit dataset none", sensor.body.sensorKey)
                                    }
                                }
                                break;
                            case "max_limit_dataset":
                                messages.push("上限値")
                                for (var sensor of self.sensors) {
                                    const sensorDataset = self.chartData.data.datasets.find((v)=>v.additionalData.sensor != null && v.additionalData.type == "max_limit_dataset" && v.additionalData.sensor.body.sensorKey == sensor.body.sensorKey)
                                    if (sensorDataset != null && sensorDataset.data[0].y == y) {
                                        messages.push(sensorDataset.additionalData.sensor.body.name + " ... " + sensorDataset.additionalData.sensor.body.alarms.measure.max.value + sensorDataset.additionalData.sensor.body.unit)
                                    } else {
                                        console.log("sensor upper limit dataset none", sensor.body.sensorKey)
                                    }
                                }
                                break;
                            case "guide_line":
                                return ""
                            case "alarm_dataset":
                                messages.push("警報")
                                messages.push(x)
                                const alarmDatasets = self.chartData.data.datasets.filter((v)=>v.additionalData.type == "alarm_dataset")
                                for (var alarmDataset of alarmDatasets) {
                                    const alarmData = alarmDataset.additionalData.alarm.history
                                    const targetSensor = self.sensors.find((v)=>v.body.sensorKey == alarmData.sensorKey && (new Date(alarmData.time)).toFormatString("yyyy-MM-dd HH:mm") == x)
                                    if (targetSensor != null) {
                                        switch (alarmData.alarmType) {
                                            case 1:
                                                messages.push(targetSensor.body.name + " ... " + "上限異常:" + alarmData.alarmData.value.toFixed(1) + targetSensor.body.unit + "(" + alarmData.alarmData.limit.toFixed(1) + targetSensor.body.unit + ")")
                                                break;
                                            case 2:
                                                messages.push(targetSensor.body.name + " ... " + "下限異常:" + alarmData.alarmData.value.toFixed(1) + targetSensor.body.unit + "(" + alarmData.alarmData.limit.toFixed(1) + targetSensor.body.unit + ")")
                                                break;
                                            case 3:
                                                messages.push(targetSensor.body.name + " ... " + "センサー異常")
                                                break;
                                        }
                                    }
                                }
                                break;
                            default:
                                messages.push("unknown("+dataset.additionalData.type+")")
                                break;
                        }
                        return messages.join("\n")

                    },
                    /**
                     * ツールチップのラベル(非表示にする)
                     */
                    label: function (tooltipItem, chart) {
                    },
                }

                /**
                 * 測定データのセット
                 */
                this.viewRange = this.condition.viewRange()

                /** センサー毎にデータセットを作成して、測定データをセット */
                this.$store.commit("processing", {start:true, message:"データを取得しています…。"})

                try {
                    for (var sensor of this.sensors) {

                        // 非表示の時は、何もしない
                        if (!sensor.isVisible) {
                            continue
                        }

                        // 警報線(min)
                        if (sensor.body.alarms.measure.min.enabled) {
                            const minLimitDataset = {
                                label: "min_limit_" + sensor.body.name,
                                data: [
                                    {
                                        x: this.viewRange.from.toFormatString("yyyy-MM-dd 00:00"),
                                        y: sensor.body.alarms.measure.min.value
                                    },
                                    {
                                        x: this.viewRange.to.toFormatString("yyyy-MM-dd 00:00"),
                                        y: sensor.body.alarms.measure.min.value
                                    }
                                ],
                                borderColor: "rgba(255,0,0,0.7)",
                                fill: true,
                                type: "line",
                                lineTension: 0.0,
                                borderWidth: 2,
                                pointRadius: self.condition.range == "day" ? 0 : 0,
                                backgroundColor: "rgba(0,0,255,0.1)",
                                additionalData: {
                                    type: "min_limit_dataset",
                                    sensor: sensor
                                },
                                yAxisID: 'y-1'
                            }
                            chartData.data.datasets.push(minLimitDataset)
                        }

                        // 警報線(max)
                        if (sensor.body.alarms.measure.max.enabled) {
                            const maxLimitDataset = {
                                label: "max_limit_" + sensor.body.name,
                                data: [
                                    {
                                        x: this.viewRange.from.toFormatString("yyyy-MM-dd 00:00"),
                                        y: sensor.body.alarms.measure.max.value
                                    },
                                    {
                                        x: this.viewRange.to.toFormatString("yyyy-MM-dd 00:00"),
                                        y: sensor.body.alarms.measure.max.value
                                    }
                                ],
                                borderColor: "rgba(255,0,0,0.7)",
                                fill: "end",
                                type: "line",
                                lineTension: 0.0,
                                borderWidth: 2,
                                pointRadius: 0,
                                backgroundColor: "rgba(255,0,0,0.1)",
                                additionalData: {
                                    type: "max_limit_dataset",
                                    sensor: sensor
                                },
                                yAxisID: 'y-1'
                            }
                            chartData.data.datasets.push(maxLimitDataset)
                        }

                        // 測定データ
                        const dataset = {
                            label: sensor.body.name,
                            data: [],
                            borderColor: this.selectedSensor != null && this.selectedSensor.body.sensorKey == sensor.body.sensorKey ? "rgba(255,0,0,0.7)" : "rgba(0,0,0,0.7)",
                            fill: false,
                            type: "line",
                            lineTension: 0.0,
                            borderWidth: this.selectedSensor != null && this.selectedSensor.body.sensorKey == sensor.body.sensorKey ? self.$vuetify.breakpoint.xs ? 2 : 4 : self.$vuetify.breakpoint.xs ? 1 : 2,
                            pointRadius: self.condition.range == "day" ? 0 : 0,
                            // pointHitRadius: 100,
                            pointHoverBorderWidth: 5,
                            additionalData: {
                                type: "measure_dataset",
                                sensor: sensor
                            },
                            yAxisID: 'y-1'
                        }

                        // sensor.chart = {dataaset: dataset}

                        chartData.data.datasets.push(dataset)

                        // console.log("date range", (new Date(this.viewRange.from)).toFormatString("yyyy-MM-dd"), (new Date(this.viewRange.to)).toFormatString("yyyy-MM-dd"))

                        // console.log(
                        //     "ChartSensor", 
                        //     "refresh", 
                        //     "measure record values find",
                        //     this.viewRange,
                        //     (new Date(this.viewRange.from)).toFormatString("yyyy-MM-dd"), 
                        //     (new Date(this.viewRange.to)).toFormatString("yyyy-MM-dd"))

                        await db.collection("environments").doc(sensor.boxMaster.boxIdentificationCode)
                        .collection("sensors").doc(sensor.body.sensorKey)
                        .collection("records")
                        .where("date", ">=", (new Date(this.viewRange.from)).toFormatString("yyyy-MM-dd"))
                        .where("date", "<", (new Date(this.viewRange.to)).toFormatString("yyyy-MM-dd"))
                        .get().then(function(snapShot) {
                            for (var doc of snapShot.docs) {
                                const record = doc.data()
                                const values = record.values
                                values.sort(function(x, y){
                                    if (x.time > y.time) return 1
                                    if (x.time < y.time) return -1
                                    return 0
                                })
                                for (var value of values) {
                                    const measureValue = value.value
                                    const x = record.date + " " + value.time
                                    const y = measureValue
                                    const data = {
                                        x: x,
                                        y: y,
                                        additionalData: {
                                            type: "measure_value",
                                            dateTime: record.date + " " + value.time,
                                            value: value,
                                            sensor: sensor
                                        }
                                    }
                                    // console.log(data)
                                    dataset.data.push(data)
                                }
                            }

                            if (dataset.data.length > 0) {
                                const max = Math.max(...dataset.data.map(m => m.y))
                                const min = Math.min(...dataset.data.map(m => m.y))
                                var total = 0
                                for (var data of dataset.data) {
                                    total += data.y
                                }
                                const ave = total / dataset.data.length

                                sensor.measureInformation = {
                                    max: max, 
                                    min: min, 
                                    average: ave, 
                                    total: total, 
                                    num: dataset.data.length
                                }
                            } else {
                                sensor.measureInformation = {
                                    max: 0, 
                                    min: 0, 
                                    average: 0, 
                                    total: 0, 
                                    num: 0
                                }
                            }
                        })

                        // /** 範囲内の警報を取得 */
                        // await db.collection("environments").doc(sensor.boxMaster.boxIdentificationCode)
                        // .collection("alarm_histories")
                        // .where("date", ">=", (new Date(this.viewRange.from)).toFormatString("yyyy-MM-dd"))
                        // .where("date", "<", (new Date(this.viewRange.to)).toFormatString("yyyy-MM-dd"))
                        // .get().then(function(snapShot) {
                        //     snapShot.forEach(function (doc){
                        //         const alarmRecord = doc.data()
                        //         console.log(alarmRecord)
                        //         const histories = alarmRecord.histories.filter((v)=>v.alarmType >= 1 && v.alarmType <= 3 && v.sensorKey == sensor.body.sensorKey)
                        //         for (var history of histories) {
                        //             sensor.alarmHistories.push(history)
                        //         }
                        //         console.log(sensor)
                        //     })
                        // })
                    }

                    /**
                     * Y軸設定
                     */
                    this.refreshYAxisRange(chartData)
                    // var y1min = 999999
                    // var y1max = -999999
                    // var y2min = 999999
                    // var y2max = -999999
                    
                    // for (var sensor of this.sensors) {
                    //     if (sensor.body.min < y1min) y1min = sensor.body.min
                    //     if (sensor.body.max > y1max) y1max = sensor.body.max
                    // }

                    // if (y1min == 999999) y1min = 0
                    // if (y1max == -999999) y1max = 1
                    // if (y2min == 999999) y2min = 0
                    // if (y2max == -999999) y2max = 1
                    
                    // chartData.options.scales.yAxes[0].ticks.min = y1min
                    // chartData.options.scales.yAxes[0].ticks.max = y1max
                    // chartData.options.scales.yAxes[0].ticks.stepSize = 1
                    // chartData.options.scales.yAxes[1].ticks.min = y2min
                    // chartData.options.scales.yAxes[1].ticks.max = y2max
                    // chartData.options.scales.yAxes[1].ticks.stepSize = 1 // y2max / 5

                    // chartData.options.zoom = {
                    //     enabled: true,
                    //     drag: true,
                    //     mode: "x",
                    //     rangeMin: {x: new Date(chartData.options.scales.xAxes[0].ticks.min).getTime()},
                    //     rangeMax: {x: new Date(chartData.options.scales.xAxes[0].ticks.max).getTime()}
                    // }

                    this.chartData = chartData

                    /**
                     * アラームの発生箇所をセット
                     */
                    this.setAlarms()

                    /**
                     * ガイドラインのデータセットを作成(初期は非表示)
                     */
                    const guideLineDataset = {
                        label: "guide_line",
                        data: [
                            {
                                x: this.guideLine.x,
                                y: chartData.options.scales.yAxes[0].ticks.min
                            },
                            {
                                x: this.guideLine.x,
                                y: chartData.options.scales.yAxes[0].ticks.max
                            },
                        ],
                        borderColor: "rgba(0,0,255,0.7)",
                        fill: false,
                        type: "line",
                        lineTension: 0.0,
                        borderWidth: 1,
                        pointRadius: 0,
                        showLine: this.guideLine.isVisible,
                        additionalData: {
                            type: "guide_line",
                        },
                        yAxisID: 'y-1'
                    }
                    chartData.data.datasets.push(guideLineDataset)
                    
                } catch (error) {
                    this.mi_writeLog("ChartSensor/refresh", error)
                } finally {
                    this.$store.commit("processing")
                }

                // /**
                //  * レンダリング
                //  */
                // this.renderChart(this.data, this.options)
                // console.log("render chart")
            },
            /**
             * チャート上に警報の線を重ねる
             */
            setAlarms: function () {

                // console.log("refreshAlarms", this.chartData, this.alarmsOnChart)

                for (var alarm of this.alarmsOnChart) {
                    const dataset = {
                        label: "alarm",
                        data: [
                            {
                                x: (new Date(alarm.time)).toFormatString("yyyy-MM-dd HH:mm"),
                                y: this.chartData.options.scales.yAxes[0].ticks.min
                            },
                            {
                                x: (new Date(alarm.time)).toFormatString("yyyy-MM-dd HH:mm"),
                                y: this.chartData.options.scales.yAxes[0].ticks.max
                            },
                        ],
                        borderColor: "rgba(255,0,0,1)",
                        fill: false,
                        type: "line",
                        lineTension: 0.0,
                        borderWidth: 1,
                        pointRadius: 0,
                        additionalData: {
                            type: "alarm_dataset",
                            alarm: alarm
                        },
                        yAxisID: 'y-1'
                    }
                    this.chartData.data.datasets.push(dataset)
                }
            },
            refreshYAxisRange: function (chartData) {

                var y1min = 999999
                var y1max = -999999
                var y2min = 999999
                var y2max = -999999

                if (this.controlValues == null || !this.controlValues.enabledYAxisFitValue) {

                    console.log("refreshYAxisRange not auto")
                    
                    for (var sensor of this.sensors) {
                        if (sensor.body.min < y1min) y1min = sensor.body.min
                        if (sensor.body.max > y1max) y1max = sensor.body.max
                    }

                    if (y1min == 999999) y1min = 0
                    if (y1max == -999999) y1max = 1
                    if (y2min == 999999) y2min = 0
                    if (y2max == -999999) y2max = 1
                    
                    chartData.options.scales.yAxes[0].ticks.min = y1min
                    chartData.options.scales.yAxes[0].ticks.max = y1max
                    chartData.options.scales.yAxes[0].ticks.stepSize = 1
                    chartData.options.scales.yAxes[1].ticks.min = y2min
                    chartData.options.scales.yAxes[1].ticks.max = y2max
                    chartData.options.scales.yAxes[1].ticks.stepSize = 1

                } else {
                    console.log("refreshYAxisRange auto")
                    chartData.options.scales.yAxes[0].display = false
                    chartData.options.scales.yAxes[1].display = false
                    const targetDatasets = chartData.data.datasets.filter((v)=>v.additionalData != null && v.additionalData.type == "measure_dataset")
                    for (var dataset of targetDatasets) {
                        for (var data of dataset.data) {
                            if (data.additionalData != null && data.additionalData.type == "measure_value") {
                                if (data.additionalData.sensor.yAxis == 1) {
                                    if (data.y < y1min) y1min = data.y
                                    if (data.y > y1max) y1max = data.y
                                    chartData.options.scales.yAxes[0].display = true
                                } else {
                                    if (data.y < y2min) y2min = data.y
                                    if (data.y > y2max) y2max = data.y
                                    chartData.options.scales.yAxes[1].display = true
                                }
                            }
                        }
                    }
                    if (chartData.options.scales.yAxes[0].display) {
                        chartData.options.scales.yAxes[0].ticks.min = Math.floor(y1min)
                        chartData.options.scales.yAxes[0].ticks.max = Math.floor(y1max) + 1
                    }
                    if (chartData.options.scales.yAxes[1].display) {
                        chartData.options.scales.yAxes[1].ticks.min = Math.floor(y1min)
                        chartData.options.scales.yAxes[1].ticks.max = Math.floor(y1max) + 1
                    }
                }
            },
            getChartData: function () {
                return this.chartData
            }
        }
    }
</script>
                // chartData.options.scales.yAxes[0].ticks.min = y1min
                // chartData.options.scales.yAxes[0].ticks.max = y1max
                // chartData.options.scales.yAxes[0].ticks.stepSize = 1
                // chartData.options.scales.yAxes[1].ticks.min = y2min
                // chartData.options.scales.yAxes[1].ticks.max = y2max
                // chartData.options.scales.yAxes[1].ticks.stepSize = 1 // y2max / 5
